<template>
  <div id="kt_body" class="kt-body kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch">
    <div
      id="kt_content"
      class="kt-content kt-content--fit-top  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
    >
      <!-- begin:: Subheader -->
      <div id="kt_subheader" class="kt-subheader   kt-grid__item">
        <div class="kt-container ">
          <div class="kt-subheader__main">
            <h3 class="kt-subheader__title">
              ค้นหาข้อความในรูปภาพ
            </h3>
            <div class="kt-subheader__breadcrumbs">
              <a href="#" class="kt-subheader__breadcrumbs-home"><i class="flaticon2-shelter" /></a>
              <span class="kt-subheader__breadcrumbs-separator" />
              <a href="" class="kt-subheader__breadcrumbs-link">
                Natural Language Processing </a>
              <span class="kt-subheader__breadcrumbs-separator" />
              <a href="" class="kt-subheader__breadcrumbs-link">
                ค้นหาข้อความในรูปภาพ</a>
            </div>
          </div>
        </div>
      </div>

      <!-- end:: Subheader -->

      <div class="kt-container  kt-grid__item kt-grid__item--fluid">
        <!-- <div class="row">
          <div class="col-xl-12">
            <div class="kt-portlet kt-portlet--height-fluid">
              <div class="kt-portlet__body">
                <div class="kt-form kt-form--label-right">
                  <div class="kt-infobox">
                    <div class="kt-infobox__body">
                      <div class="kt-infobox__section">
                        <div class="kt-infobox__content">
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                          scrambled a type specimen book text of the dummy text of the
                          printing printing and typesetting industry scrambled dummy text of
                          the printing.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div class="col-xl-6">
            <!--begin::Portlet-->
            <div class="kt-portlet kt-portlet--height-fluid">
              <!--begin::Form-->
              <form class="kt-form kt-form--label-right" enctype="multipart/form-data">
                <div class="kt-portlet__body">
                  <div class="kt-infobox">
                    <div class="kt-infobox__header engin-option">
                      <h2 class="kt-infobox__title kt-font-success">
                        อัพโหลดรูปภาพที่นี่
                      </h2>
                      <div
                        class="algorithm-selector form-group row"
                        style="justify-content: flex-end;margin: auto 0 auto 0"
                      >
                        <div>
                          <select
                            id="ocr-engine"
                            v-model="selectedEngineCode"
                            name="engine"
                            :disabled="processing"
                            class="form-control"
                            @change="trackCustomEvent({ action: 'clicked', target: 'selector_content', value: selectedEngineCode }); submit()"
                          >
                            <option v-for="(e, idx) in engines" :key="idx" :value="e.code">
                              {{ e.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="kt-infobox__body">
                      <div class="form-group">
                        <div id="kt_dropzone_3" class="dropzone dropzone-default">
                          <div class="dropzone-msg dz-message needsclick">
                            <h3 class="dropzone-msg-title">
                              ลากไฟล์มาวางที่นี่หรือคลิกเพื่ออัพโหลด
                            </h3>
                            <span class="dropzone-msg-desc">รองรับไฟล์รูปภาพนามสกุล .jpg .png .gif</span>
                          </div>
                        </div>
                      </div>
                      <div class="kt-form__actions kt-form__actions--center">
                        <div class="row">
                          <div class="col kt-align-middle">
                            <button
                              type="button"
                              class="btn btn-secondary"
                              :disabled="processing"
                              @click="trackCustomEvent({ action: 'clicked', target: 'random_content' }); random()"
                            >
                              Random
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!--end::Portlet-->
          </div>

          <div class="col-xl-6">
            <!--begin::Portlet-->
            <div class="kt-portlet kt-portlet--height-fluid">
              <div class="kt-portlet__body">
                <div class="kt-infobox">
                  <div class="kt-infobox__header">
                    <h2 class="kt-infobox__title">
                      ข้อความที่พบในรูปภาพ
                    </h2>
                  </div>
                  <div class="kt-infobox__body">
                    <div class="kt-infobox__section">
                      <div class="kt-infobox__content">
                        <div v-if="!processing">
                          {{ text }}
                        </div>
                        <div v-else class="d-flex justify-content-center">
                          <svg
                            width="30%"
                            height="100"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 100 100"
                            preserveAspectRatio="xMidYMid"
                          >
                            <g transform="translate(20 50)">
                              <circle cx="0" cy="0" r="6" fill="#fdfdfd" transform="scale(0.873341 0.873341)">
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="-0.375s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                />
                              </circle>
                            </g>
                            <g transform="translate(40 50)">
                              <circle cx="0" cy="0" r="6" fill="#85a2b6" transform="scale(0.996005 0.996005)">
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="-0.25s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                />
                              </circle>
                            </g>
                            <g transform="translate(60 50)">
                              <circle cx="0" cy="0" r="6" fill="#bbcedd" transform="scale(0.789675 0.789675)">
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="-0.125s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                />
                              </circle>
                            </g>
                            <g transform="translate(80 50)">
                              <circle cx="0" cy="0" r="6" fill="#dce4eb" transform="scale(0.444673 0.444673)">
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="0s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                />
                              </circle>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--end::Portlet-->
          </div>
        </div>
      </div>
      <!-- end:: Content -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ws from '../ws'
// import axios from 'axios'

const defaultText = 'อัพโหลดรูปภาพเพื่อทดลองใช้งาน'
const emptyText = 'ไม่พบข้อความในรูปภาพ'
const errorText = 'พบข้อผิดพลลาดในระบบ กรุณาลองใหม่ภายหลัง'

export default {
  data () {
    return {
      dropzone: null,
      text: defaultText,
      imagePool: [
        // 'https://codelabs.developers.google.com/codelabs/mobile-vision-ocr/img/c5134dae01ad22a5.png',
        '/assets/ocr/ocr_text1.png',
        '/assets/ocr/ocr_text2.png',
        '/assets/ocr/ocr_text3.png'
      ],
      dropFile: null,
      processing: false,
      thumbnail: false,
      selectedEngineCode: '',
      engines: [
        {
          code: 'speed',
          name: 'เน้นความเร็ว',
          desc: 'เน้นความเร็ว'
        },
        {
          code: 'accuracy',
          name: 'เน้นความถูกต้อง',
          desc: 'เน้นความถูกต้องแม่นยำ แต่อาจจะใช้เวลานานขึ้น'
        },
        {
          code: 'smart',
          name: 'ให้ระบบเลือกอัตโนมัติ',
          desc: 'ให้ระบบเลือกวิธีที่เหมาะที่สุดให้'
        }
      ],
      currentImageUrl: ''
    }
  },
  computed: {
    isDefaultText () {
      return this.text === defaultText
    },
    isEmptyText () {
      return this.text === emptyText
    }
  },
  mounted () {
    this.selectedEngineCode = this.engines[0].code
    const state = this
    this.shuffle()
    const dropzoneElement = window.$('#kt_dropzone_3').dropzone({
      url: `${ws.hostname}/nlp/ocr?token=${ws.token}`,
      paramName: 'image',
      maxFilesize: 4, // MB
      uploadMultiple: false,
      addRemoveLinks: true,
      thumbnailWidth: null,
      thumbnailHeight: null,
      thumbnailMethod: 'contain',
      acceptedFiles: 'image/*',
      init: function () {
        this.on('thumbnail', function (file, dataUrl) {
          window.$('.dz-preview').css({
            width: '100%',
            height: 'auto',
            margin: 0,
            'z-index': 0
          })
          window.$('.dz-image').css({
            width: '100%',
            height: 'auto',
            margin: 0
          })
          window.$('.dz-image').last().find('img').attr({
            width: '100%',
            height: 'auto',
            margin: 0
          })
          window.$('.dz-image').last().find('img').css({
            filter: 'none',
            transform: 'none'
          })
          window.$('.dz-details').last().attr({ hidden: true })
          window.$('.dz-error-message').last().attr({ hidden: true })
        })
        this.on('addedfile', function (file) {
          if (this.files.length > 1) {
            const oldFile = this.files[0]
            this.removeFile(oldFile)
          }
          state.trackCustomEvent({ event: 'input', action: 'upload', target: 'input_box_content' })
        })
        this.on('processing', function (file, response) {
          state.processing = true
        })
        this.on('sending', function (file, xhr, formData) {
          xhr.timeout = 60000
          xhr.ontimeout = function (e) {
            state.processing = false
            state.text = errorText
          }
        })
        this.on('success', function (file, response) {
          state.text = response.results.text || emptyText
        })
        this.on('complete', function () {
          state.processing = false
        })
        this.on('error', function () {
          state.processing = false
          state.text = errorText
        })
        this.on('canceled', function () {
          state.processing = false
          state.text = defaultText
        })
        this.on('removedfile', function (file, response) {
          state.text = defaultText
          state.trackCustomEvent({ action: 'clicked', target: 'links_content' })
        })
      }
    })
    const dropzone = dropzoneElement[0].dropzone
    this.dropzone = dropzone
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    }),
    shuffle () {
      for (let i = this.imagePool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this.imagePool[i], this.imagePool[j]] = [this.imagePool[j], this.imagePool[i]]
      }
      return this.imagePool
    },
    async random () {
      if (this.imagePool.length > 0) {
        this.processing = true
        if (this.dropzone.files.length > 1) {
          const oldFile = this.dropzone.files[0]
          this.dropzone.removeFile(oldFile)
        }
        const currentRandomImage = this.imagePool.shift()
        this.imagePool.push(currentRandomImage)
        this.currentImageUrl = currentRandomImage

        const imageFile = await this.urlToFile(this.currentImageUrl, 'RandomImage.png', 'image/png')
        this.dropzone.files.push(imageFile)
        this.dropzone.emit('addedfile', imageFile)
        this.dropzone.emit('thumbnail', imageFile, currentRandomImage)
        const formData = new FormData()
        formData.append('image', imageFile)
        formData.append('engine', this.selectedEngineCode)

        try {
          const result = await ws.ocr(formData, this.selectedEngineCode)
          this.text = result.results.text || emptyText
          this.dropzone.emit('complete', imageFile)
          this.processing = false
        } catch (e) {
          this.text = errorText
          this.dropzone.emit('error', imageFile)
          this.processing = false
        }
      }
    },
    async submit () {
      this.processing = true
      if (this.dropzone.files.length > 1) {
        const oldFile = this.dropzone.files[0]
        this.dropzone.removeFile(oldFile)
      }

      const imageFile = await this.urlToFile(this.currentImageUrl, 'RandomImage.png', 'image/png')
      const formData = new FormData()
      formData.append('image', imageFile)
      formData.append('engine', this.selectedEngineCode)

      try {
        const result = await ws.ocr(formData)
        this.text = result.results.text || emptyText
        this.processing = false
      } catch (e) {
        this.text = errorText
        this.processing = false
      }
    },
    base64ToArrayBuffer (base64) {
      const binaryString = atob(base64)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    async urlToFile (url, filename, mimeType) {
      return new Promise((resolve, reject) => {
        // let canvas = document.createElement('CANVAS')
        // const img = document.createElement('img')
        // img.src = this.url
        // img.onload = function () {
        //   canvas.height = img.height
        //   canvas.width = img.width
        //   const base64 = canvas.toDataURL('image/png')
        //   canvas = null
        //   base64ToArrayBuffer()
        //   const the_file = new Blob([atob(base64)], { type: 'image/png', encoding: 'utf-8' })
        //   const fr = new FileReader()
        // }
        // img.onerror = function (error) {
        //   reject(error)
        // }
        fetch(url)
          .then(function (res) { return res.arrayBuffer() })
          .then(function (buf) { return resolve(new File([buf], filename, { type: mimeType })) })
      })
    }
  }
}
</script>

<style scoped>

    .form-group label {
        font-size: 1.15rem;
    }

    textarea.form-control {
        font-size: 1.25rem;
    }

    .kt-subheader--transparent .kt-subheader .kt-subheader__main .kt-subheader__title {
        font-size: 2.5rem;
    }

    .kt-infobox__content > span {
        line-height: 3rem;
    }

    .dz-preview .dz-image {
        width: 100%;
        height: auto;
    }

    .dz-image > img {
        width: 100%;
        height: auto;
    }

    .kt-infobox__header.engin-option {
      justify-content: space-between;
    }
</style>
